<template lang="pug">
.searchbar
  .input-group
    .input-group-prepend
      span.input-group-text
        i.fas.fa-search
    input.form-control(type="text" :placeholder="$t('ui.select_leagues')" @input="handleInput")
    #cancel-league.input-group-prepend.cancel(@click="save")
      span {{ $t("ui.save") }}
</template>

<script>
export default {
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value);
    },
    save() {
      this.$emit('save');
    }
  }
}
</script>